/* eslint-disable @typescript-eslint/naming-convention */

declare global {
  interface Window {
    REACT_APP_ENV: string;
    REACT_APP_GATEWAY_URL: string;
    REACT_APP_KEYCLOAK_REALM: string;
    REACT_APP_KEYCLOAK_URL: string;
    REACT_APP_KEYCLOAK_CLIENT_ID: string;
    REACT_APP_INPUT_URL: string;
    REACT_APP_USER_URL: string;
    REACT_APP_PROGRAM_URL: string;
    REACT_APP_A8_URL: string;
    REACT_APP_WORKFLOW_URL: string;
    REACT_APP_REPORTS_URL: string;
    REACT_APP_COMMUNICATION_URL: string;
  }
}

const REACT_APP_ENV: string = window.REACT_APP_ENV || process.env.REACT_APP_ENV;
const REACT_APP_GATEWAY_URL: string =
  window.REACT_APP_GATEWAY_URL || process.env.REACT_APP_GATEWAY_URL;
const REACT_APP_KEYCLOAK_REALM: string =
  window.REACT_APP_KEYCLOAK_REALM || process.env.REACT_APP_KEYCLOAK_REALM;
const REACT_APP_KEYCLOAK_URL: string =
  window.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL;
const REACT_APP_KEYCLOAK_CLIENT_ID: string =
  window.REACT_APP_KEYCLOAK_CLIENT_ID ||
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const REACT_APP_INPUT_URL: string =
  window.REACT_APP_INPUT_URL || process.env.REACT_APP_INPUT_URL;
const REACT_APP_USER_URL: string =
  window.REACT_APP_USER_URL || process.env.REACT_APP_USER_URL;
const REACT_APP_PROGRAM_URL: string =
  window.REACT_APP_PROGRAM_URL || process.env.REACT_APP_PROGRAM_URL;
const REACT_APP_A8_URL: string =
  window.REACT_APP_A8_URL || process.env.REACT_APP_A8_URL;
const REACT_APP_WORKFLOW_URL: string =
  window.REACT_APP_WORKFLOW_URL || process.env.REACT_APP_WORKFLOW_URL;
const REACT_APP_REPORTS_URL: string =
  window.REACT_APP_REPORTS_URL || process.env.REACT_APP_REPORTS_URL;
const REACT_APP_COMMUNICATION_URL: string =
  window.REACT_APP_COMMUNICATION_URL || process.env.REACT_APP_COMMUNICATION_URL;

const SERVICE = {
  USER: 'services/user/api/v1',
};

const MODULE = {
  USER_MANAGEMENT: 'user_management',
  ORGANIZATION: 'organization',
};

const buildUrl = (service: string, moduleName: string): string =>
  `${REACT_APP_GATEWAY_URL}/${service}/${moduleName}`;

const REACT_APP_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.USER_MANAGEMENT
);
const REACT_APP_API_URL_ORG: string = buildUrl(
  SERVICE.USER,
  MODULE.ORGANIZATION
);
const REACT_APP_USER_API_URL: string = REACT_APP_API_URL;

export {
  REACT_APP_ENV,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_INPUT_URL,
  REACT_APP_USER_URL,
  REACT_APP_PROGRAM_URL,
  REACT_APP_A8_URL,
  REACT_APP_WORKFLOW_URL,
  REACT_APP_API_URL_ORG,
  REACT_APP_USER_API_URL,
  REACT_APP_REPORTS_URL,
  REACT_APP_COMMUNICATION_URL,
};
